import { safeWebUrl } from "@/lib/safe-web-url";

/** Infer the canonical repository from trusted web-shaped PR/run links. */
export function githubRepository(urls: readonly unknown[]): {
  name: string;
  url: string;
} | null {
  for (const candidate of urls) {
    const safe = safeWebUrl(
      typeof candidate === "string" ? candidate : undefined,
    );
    if (!safe) continue;
    const url = new URL(safe);
    if (url.hostname !== "github.com" || url.username || url.password) continue;
    const [owner, repository] = url.pathname.split("/").filter(Boolean);
    if (
      !owner ||
      !repository ||
      !/^[\w.-]+$/.test(owner) ||
      !/^[\w.-]+$/.test(repository)
    )
      continue;
    return {
      name: repository,
      url: `https://github.com/${owner}/${repository}`,
    };
  }
  return null;
}

export function githubCommitUrl(
  repositoryUrl: string | undefined,
  sha: string,
): string | null {
  if (!repositoryUrl || !/^[a-f\d]{7,40}$/i.test(sha)) return null;
  const repository = githubRepository([repositoryUrl]);
  return repository ? `${repository.url}/commit/${sha}` : null;
}
